<template>
  <validation-observer ref="simpleRules">
    <b-form
      v-bind="$attrs"
      :class="isHesbaClient ? 'ps-g-form' : null"
      @keydown.enter.capture="onFormKeydownEnter"
      @submit.prevent="validationForm"
      novalidate
    >
      <slot />
    </b-form>
  </validation-observer>
</template>

<script>
import { ValidationObserver } from 'vee-validate'

import '@validations'

export default {
  components: {
    ValidationObserver,
  },
  emits: ['update:isValid', 'submit'],
  props: {
    isValid: {
      type: Boolean,
      default: true,
    },
  },
  mounted() {
   this.$refs.simpleRules.validate();
  },
  methods: {
    onFormKeydownEnter(e) {
      const t = e.target;
      if (!t || !t.tagName) return;
      if (t.closest && t.closest('[data-allow-enter="true"]')) return;
      if (t.tagName === 'TEXTAREA') return;
      if (t.tagName === 'INPUT') {
        const type = (t.getAttribute('type') || 'text').toLowerCase();
        if (['button', 'submit', 'reset', 'checkbox', 'radio', 'file', 'hidden'].includes(type)) {
          return;
        }
        e.preventDefault();
      }
    },
    validationForm() {
      this.$refs.simpleRules.validate().then((success) => {
        // eslint-disable-next-line
        this.$emit('update:isValid', success);
        if (success) {
          this.$emit('submit')
        }
      })
      return false;
    },
  },
}
</script>
